import { isFulfilled } from '@reduxjs/toolkit';

import { accountsActions } from '@modules/accounts';
import { buyActions } from '@modules/buy';
import { cardsActions } from '@modules/cards';
import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';
import { userActions } from '@modules/user';
import { walletActions } from '@modules/wallet';

const ignoreActions = [
  loginActions.keepAlive.fulfilled.type,
  cardsActions.getBindStatusPolling.fulfilled.type,
  buyActions.getBuyStatusPolling.fulfilled.type,
  userActions.getUserDataPolling.fulfilled.type,
  accountsActions.getAccountLimitsPolling.fulfilled.type,
  accountsActions.getAccountsPolling.fulfilled.type,
  walletActions.getWalletLimitsPolling.fulfilled.type,
  walletActions.getWalletPolling.fulfilled.type,
];
let isStopRequest = false;

export const updateExpiredTime: TMiddleware = store => next => action => {
  const { login } = store.getState();
  if (
    isFulfilled(action) &&
    !ignoreActions.includes(action.type) &&
    !isStopRequest &&
    login.isLoggedIn
  ) {
    isStopRequest = true;
    store.dispatch(loginActions.keepAlive());
    setTimeout(() => {
      store.dispatch(loginActions.keepAlive());
      isStopRequest = false;
    }, CONST.keepAliveInterval);
  }

  return next(action);
};

export default updateExpiredTime;
